<template>
	<div class="main_section my-bookings-page" :class="($route.name === 'int_my_bookings') ? 'p-3' : ''">

		<div v-if="$route.name === 'int_my_bookings' && item_selected !== null">
			<vs-popup :title="item_selected_title" :active.sync="show_pop_up_row">
		      <div>
		      	<div class="vs-con-table stripe vs-table-primary">
		      		<div class="con-tablex vs-table--content">
		      			<div class="vs-con-tbody vs-table--tbody " style="max-height:auto;">
		      				<table class="vs-table vs-table--tbody-table">
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('tipo_de_marcacao')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.rsv_type}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('tipo_de_espaco')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.space_type_name}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('data_do_registo')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.created_date}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('mesas')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.ocupacao_mesa_str}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('n_quarto')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.room_number}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('grupo')}}</td></b>
		      						<td class="td vs-table--td" v-if="item_selected.rooms_number_in_group !== 'ver'">{{item_selected.rooms_number_in_group}}</td>
		      						<td class="td vs-table--td" v-else v-on:click="see_group(item_selected.n_grupo)"><b style="color: #58CCC2; cursor: pointer;">{{$t('ver')}}</b></td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('n_presenças')}}</td></b>
		      						<td class="td vs-table--td" v-if="occupancy_edit"><div class="text-left"><vs-input-number class="w-1/4" min="0" v-model="item_selected.num_people_show"/></div></td>
									<td class="td vs-table--td" v-else>{{item_selected.num_people_show}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('registado_por')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.created_by}}</td>
		      					</tr>
		      					<tr class="tr-values vs-table--tr tr-table-state-null">
		      						<b><td class="td vs-table--td">{{$t('observacoes')}}</td></b>
		      						<td class="td vs-table--td">{{item_selected.observations}}</td>
		      					</tr>
		      				</table>
		      			</div>
		      		</div>
		      	</div>
		      </div>
		      <div class="text-right mt-4">
		      	<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="success" type="filled" v-on:click="send_people_show()" v-if="occupancy_edit">{{$t('Gravar')}}</vs-button>
				<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="danger" type="filled" v-on:click="show_pop_up_row=false">{{$t('sair')}}</vs-button>
		      </div>
		    </vs-popup>
		</div>
		<div v-if="$route.name === 'int_my_bookings'">
			<vs-popup :title="$t('Pesquisa')" :active.sync="show_pop_up_filter">
				<div class="inline-block w-full">
					<div class="vx-col w-full mb-5">
						<small class="block">{{$t('date')}}</small>
						<datepicker 
							class="w-full filter_date" 
							v-model="filter.date" 
							format="dd/MM/yyyy"
							:highlighted="date_options.highlightedDates"
							:disabledDates="date_options.disabledDates"
							:language="date_options.languages.pt">
						</datepicker>
					</div>
					<div class="vx-col w-full mb-5">
						<small class="block">{{$t('space')}}</small>
						<v-select class="w-full" @focus="keyboard_show" :clearable="false" v-model="filter.space_hotel" :options="spaces" label="name" style="padding-top: 8px;">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
                		</v-select>
					</div>
					<div class="vx-col w-full mb-5">
						<small class="block">{{$t('service_type')}}</small>
						<v-select class="w-full"
							:clearable="true"
							:searchable="false"
							v-model="filter.service_type"
							:options="service_type_list"
							label="name"
							:disabled="(this.filter.space_hotel.space_type_id != 1 && spaces.length > 0) ||
									(this.$route.name === 'int_my_bookings' && this.$route.params.interface == 3) ? true : false">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
                		</v-select>
                	</div>
					<div class="vx-col w-full mb-5">
						<small class="block">{{$t('horarios')}}</small>
						<v-select class="w-full" @focus="keyboard_show" :clearable="true" v-model="filter.schedule" :options="schedule_list" label="label">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
                		</v-select>
					</div>
					<div class="vx-col w-full mb-5 mb-5">
						<small class="block">{{$t('rsv_number')}}</small>
						<vs-input class="w-full" @focus="keyboard_show" type="number" data-layout="numeric" v-model="filter.num_reserva"/>
					</div>
					<div class="vx-col w-full mb-5">
						<small class="block">{{$t('room_number')}}</small>
						<vs-input class="w-full" @focus="keyboard_show" type="number" data-layout="numeric" v-model="filter.room_number"/>
					</div>
					<div class="vx-col w-full mb-5">
						<small class="block">{{$t('nome')}}</small>
						<vs-input class="w-full" @focus="keyboard_show" data-layout="normal" v-model="filter.name"/>
					</div>
					<div class="vx-col w-full mb-5">
						<vs-checkbox class="w-full" v-model="filter.group">{{$t('Grupos')}}</vs-checkbox>
					</div>
				</div>
				<div class="text-right">
					<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1 mt-6 mb-4" color="primary" type="filled" v-on:click="filter_clean">{{$t('Limpar')}}</vs-button>
					<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1 mt-6 mb-4" color="primary" type="filled" v-on:click="filter_list">{{$t('Pesquisar')}}</vs-button>
				</div>
		    </vs-popup>

		</div>

		<!-- <div class="logo" v-if="$route.name === 'int_my_bookings'">
            <img :src="require('@/assets/images/logo/Logotipo_Verde.png')" alt="logo" class="w-10 mr-4 align-middle">
            <span style="color: #476061" class="logo-text -my-1 align-middle"><em>My</em> Vila Galé</span>
        </div> -->

		<div v-if="$route.name === 'int_my_bookings'">
			<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
				<span class="cursor-pointer flex i18n-locale"><img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2"></span></span>
				<vs-dropdown-menu class="w-50 i18n-dropdown">
					<vs-dropdown-item @click="updateLocale('en')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('pt')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('br')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('de')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('fr')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('es')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

        <div v-if="$route.name === 'int_my_bookings'"> 
			<h1 :class="(($route.name === 'int_my_bookings')) ? 'my-5' : ''">{{$t('appointments')}}</h1>
			<h4 class="mt-2">{{user.hotel.hotel_name}}</h4>
			<p class="mt-3" v-if="($route.name !== 'int_my_bookings')">{{$t('my_bookings_sentence')}}</p>
		</div>

		<div class="text-right mt-6 mb-3" v-if="$route.name === 'int_my_bookings'">
			<vs-button class="mr-4" color="primary" v-on:click="show_pop_up_filter = true">{{$t('Pesquisa')}}</vs-button>
			<router-link class="inline-block" :to="($route.name === 'int_my_bookings') ? {name: 'int_bookings', params: $route.params} : {name: 'bookings'}"><vs-button color="primary">{{$t('newa')}}</vs-button></router-link>
		</div>
		<div class="w-full mt-8">

            <vx-card v-if="($route.name === 'int_my_bookings' && comp_analitics.length > 0 && str_filter_space_hotel != null && str_filter_date != null)" :title="str_filter_space_hotel+ ' | ' +str_filter_date" class="stats-card">
                <div class="flex mb-5">
                    <span class="flex items-center">
                        <div class="h-3 w-3 rounded-full mr-1" style="background-color: #63c0bb;"></div>
                        <span>{{$t('people_n')}}</span>
                    </span>
                    <span class="flex items-center ml-4">
                        <div class="h-3 w-3 rounded-full mr-1 bg-warning"></div>
                        <span>{{$t('places_n')}}</span>
                    </span>
                </div>
				<div v-for="(item, index) in comp_analitics" :key="index" :class="{'mt-4': index}">
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <span class="mb-1">{{item.label}}</span>
                            <h4>{{item.total_current_occupancy}}</h4>
                        </div>
                        <div class="flex flex-col text-right">
                            <span class="flex -mr-1">
                                <span class="mr-1 mt-5">{{item.max_occupancy}}</span>
                            </span>
                        </div>
                    </div>
                    <vs-progress :percent="item.percent"></vs-progress>

					<div class="flex justify-between mt-2">
                        <div class="flex flex-col">
                            <h4>{{item.total_seats_occupancy}}</h4>
                        </div>
                        <div class="flex flex-col text-right">
                            <span class="flex -mr-1">
                                <span class="mr-1">{{item.max_occupancy}}</span>
                            </span>
                        </div>
                    </div>
                    <vs-progress :percent="item.percent_seats" color="warning"></vs-progress>
                </div>
            </vx-card>
          
			<vx-card class="mt-8 mb-8">
				<div>
					<vs-table class="bookings-table stripe mt-2" search pagination max-items="20" :data="bookings" :noDataText="$t('bookings_no_items')" ref="tabela">
					  <template slot="thead">
							<vs-th sort-key="n_grupo" v-if="$route.name === 'int_my_bookings'">
								{{$t('n_grupo')}}
							</vs-th>
							<vs-th sort-key="reservation_number">
								{{$t('rsv_number')}}
							</vs-th>
							<vs-th sort-key="room_number" v-if="$route.name === 'int_my_bookings'">
								{{$t('room_number')}}
							</vs-th>
							<vs-th sort-key="regime" v-if="$route.name === 'int_my_bookings'">
								{{$t('regime')}}
							</vs-th>
							<vs-th sort-key="name" v-if="$route.name === 'int_my_bookings'">
								{{$t('nome')}}
							</vs-th>
							<vs-th sort-key="space_type_name" v-if="$route.name !== 'int_my_bookings'" >
								{{$t('space_type')}}
							</vs-th>
							<vs-th sort-key="space_name">
								{{$t('space')}}
							</vs-th>
							<vs-th sort-key="service_name">
								{{($route.name === 'int_my_bookings') ? 'Tipo de Serviço' : $t('service_type')}}
							</vs-th>
							<vs-th sort-key="reservation_date">
							    {{$t('date')}}
							</vs-th>
							<vs-th sort-key="start_time">
							    {{$t('horario')}}
							</vs-th>
							<vs-th sort-key="occupancy">
								{{$t('people_n')}}
							</vs-th>
							<vs-th v-if="$route.name === 'int_my_bookings'">
								{{$t('n_presencas')}}
							</vs-th>
							<vs-th>
								{{$t('cancels')}}
							</vs-th>
						</template>	

						<template slot-scope="{data}">
							<vs-tr 
								:key="idx" 
								v-for="(item, idx) in data" 
								:state="$route.name === 'int_my_bookings' && item.num_people_show > 0 ? 'success' : $route.name === 'int_my_bookings' && item.n_grupo != '---' ? 'warning':null" 
								:class="($route.name === 'int_my_bookings') ? 'cursor-pointer' : ''" 
								v-on:click.native="handleSelected(item)">
								<vs-td v-if="$route.name === 'int_my_bookings'">
									{{item.n_grupo}}
								</vs-td>
								<vs-td>
									{{item.reservation_number}}
								</vs-td>
								<vs-td v-if="$route.name === 'int_my_bookings'">
									{{item.room_number}}
								</vs-td>
								<vs-td v-if="$route.name === 'int_my_bookings'">
									{{item.regime}}
								</vs-td>
								<vs-td v-if="$route.name === 'int_my_bookings'" v-html="item.name !== null ? item.name : '---'"></vs-td>
								<vs-td v-if="$route.name !== 'int_my_bookings'">
									{{item.space_type_name}}
								</vs-td>
								<vs-td>
									{{item.space_name}}
								</vs-td>
								<vs-td>
									{{item.service_name}}
								</vs-td>
								<vs-td>
									{{item.reservation_date}}
								</vs-td>
								<vs-td>
									{{get_hour_interval_str(item.start_time, item.end_time)}}
								</vs-td>
								<vs-td>
									{{item.occupancy}}
								</vs-td>
								<vs-td v-if="$route.name === 'int_my_bookings'">
									<span v-html="item.num_people_show"></span>
								</vs-td>
								<vs-td>
									<div :title="(item.can_cancel == 1) ? $t('cancels') : ''" class="text-center">
										<XCircleIcon v-if="item.can_cancel == 1" v-on:click.stop="cancel_reservation(item.reservation_id,item.reservation_distribution_id)" stroke="red" class="cursor-pointer"></XCircleIcon> 
									 	<span v-else>---</span> 
								 	</div>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</vx-card>
			<vue-touch-keyboard class="v-touch-keyboard" :options="keyboard.options" v-if="keyboard.visible && $route.params.pos == 1 && !isMobile()" :layout="keyboard.layout" :cancel="keyboard_hide" :accept="keyboard_accept" :input="keyboard.input" />
		</div>
	</div>
</template>

<script>
import { XCircleIcon } from 'vue-feather-icons';
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

import VueTouchKeyboard from "vue-touch-keyboard";
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style


export default {
	components: {
		XCircleIcon,
		Datepicker,
		vueTouchKeyboard: VueTouchKeyboard.component
	},
	data(){
		return {
			analytics: [],
			user: JSON.parse(localStorage.getItem('userSession')),
			bookings: [],
			user_token: null,
			spaces: [],
			date_selected: new Date(),
			saving: false,
			space_selected: null,
			dp: {
				disabledDates: {dates: []},
			    languages: {
		        	pt: ptBR,
		        },
	    	},
	    	keyboard: {
				visible: false,
		      	layout: "normal",
		      	input: null,
		      	options: {
			        useKbEvents: false
			    }
		  	},
			item_selected: null,
			show_pop_up_row: false,
			show_pop_up_filter: false,
			service_type_list: [],
			service_type_list_save: [],
			filter: {
				date: null, //moment(new Date()).format('YYYY-MM-DD'),
				space_hotel: {
					name: null,
					space_hotel_id: null,
					service_type: null,
				},
				service_type: null,
				schedule: null,
				num_reserva: null,
				room_number: null,
				name: null,
				group: null,
			},
			original_filter_space_hotel: {
				name: null,
				space_hotel_id: null,
				service_type: null,
			},
			str_filter_space_hotel: '',
			str_filter_date: '',
			schedule_list: [],
			horarios: [],
			date_options: {
				disabledDates: {dates: []},
			    languages: {
		        	pt: ptBR,
		        },
				highlightedDates: {
						dates: [new Date()]
				},
	    	},
	    	cleaning: false,
			occupancy_edit: true,
		}
	},
	methods: {
		see_group(n_grupo){
			this.get_my_bookings(false, false, n_grupo);
		},
		trigger_dp: function() {
			this.$refs.dp.showCalendar();
		},
		filter_list(){
        	this.get_my_bookings();
        },
        filter_clean(){
			if(this.filter.date != moment(new Date()).format('YYYY-MM-DD')){
				this.cleaning = true;    
			}
        	this.filter = {
				date: null, //moment(new Date()).format('YYYY-MM-DD'),
				space_hotel: this.original_filter_space_hotel,
				service_type: null,
				schedule: null,
				num_reserva: null,
				room_number: null,
				name: null,
				group: null,
			};
        },
		cancel_reservation: function(rsv_id, rsv_distribution_id) {
			let that = this;
			that.$vs.loading();
			this.$api({
				method: 'post',
				url: '/myvilagale/bookings/cancel_booking',
				data: {
					token: this.user_token,
					reservation_distribution_ids: [rsv_distribution_id],
					reservation_id : rsv_id,
					send_email: true
				},
			})
			.then(function (res) {
				that.$vs.notify({
                    text: that.$t('booking_removed'),
                    color:'success',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-check'
                });
				that.get_my_bookings();
			}) 
			.catch( function (err) {
    			that.notify('ERR.', 'red');
			})
			.then(function() {
				// that.$vs.loading.close();
			});
		},
		get_my_bookings: function(first = false, onlySpaces = false, n_grupo = false) {
			// if(!first && this.filter.space_hotel == null){
			// 	this.notify('Selecione um Espaço', 'red');
			// 	return false;
			// }
			if(!onlySpaces){
				this.bookings = [];
			}
			
			this.$vs.loading();
			let that = this;

			let bookingList_string = '';
			if(this.$route.name !== 'int_my_bookings'){
				
				let bookingList = this.$user.bookingList;

				for (let i = 0; i < bookingList.length; i++) {
					if(i !== 0){
						bookingList_string += ', ';
					}
					bookingList_string += bookingList[i].num_reserva;
				}
			}
			
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/get_my_bookings',
				params: {
					token: this.user_token,
					num_reserva: (this.$route.name === 'int_my_bookings') ? null : bookingList_string,
					cod_hotel: this.user.hotel.hotel_id,
					lang: this.$i18n.locale,
					interface: (this.$route.name === 'int_my_bookings') ? this.$route.params.interface : 1,
					filter_date: (this.$route.name === 'int_my_bookings') ? ((this.filter.date == null) ? null : moment(this.filter.date).format('YYYY-MM-DD')) : null,
					filter_space_hotel: (this.$route.name !== 'int_my_bookings') ? null : (onlySpaces) ? null : this.filter.space_hotel.space_hotel_id,
					filter_service_type: (this.$route.name === 'int_my_bookings') ? (this.filter.service_type != null) ? this.filter.service_type.service_type_id : null : null,
					filter_schedule: (this.$route.name === 'int_my_bookings') ? (this.filter.schedule != null) ? this.filter.schedule.space_schedule_id : null : null,
					filter_num_reserva: (this.$route.name === 'int_my_bookings') ? this.filter.num_reserva : null,
					filter_room_number: (this.$route.name === 'int_my_bookings') ? this.filter.room_number : null,
					filter_name: (this.$route.name === 'int_my_bookings') ? this.filter.name : null,
					filter_group: (this.$route.name === 'int_my_bookings') ? this.filter.group : null,
					service_type_list: (this.$route.name === 'int_my_bookings') ? ((this.service_type_list.length == 0) ? 'get' : null) : null,
					//first: (this.$route.name === 'int_my_bookings') ? first : null,
					onlySpaces: onlySpaces,
					n_grupo: n_grupo,
				},
			}).then(function (res) {
				if(onlySpaces){
					that.spaces = res.data.spaces;

					if(that.cleaning == false){
						that.filter.space_hotel = {
							name: null,
							space_hotel_id: null,
							service_type: null,
						};

						if(that.spaces.length == 0){
							that.filter.space_hotel.name = null;
							that.filter.space_hotel.space_hotel_id = null;
							that.filter.space_hotel.space_type_id = null;
						}else{
							that.service_type_list = (res.data.service_type_list == null) ? that.service_type_list : res.data.service_type_list;
							that.filter.space_hotel.name = that.spaces[0].name;
							that.filter.space_hotel.space_hotel_id = that.spaces[0].space_hotel_id;
							that.filter.space_hotel.space_type_id = that.spaces[0].space_type_id;
						}
					}
					that.cleaning = false;
					
    				that.$vs.loading.close();
				}else{
					if(res.data.bookings.length == 0){
						that.bookings = res.data.bookings;
					}else{
						// colocar numero de quartos nas reservas de grupo
						that.bookings = res.data.bookings.map(function(item, index){
							item.rooms_number_in_group = '';
							if(item.n_grupo != '---'){
								for (let i = 0; i < res.data.bookings.length; i++) {
									if(res.data.bookings[i].n_grupo == item.n_grupo && 
										res.data.bookings[i].reservation_id != item.reservation_id &&
										res.data.bookings[i].room_number != '---'){
										item.rooms_number_in_group += res.data.bookings[i].room_number + ', ';
									}
								}
							}

							// retirar a ultima virgula
							if(item.rooms_number_in_group != '' && item.n_grupo != '---'){
								item.rooms_number_in_group = item.rooms_number_in_group.slice(0, -2);
							}else if(item.rooms_number_in_group == '' && item.n_grupo != '---'){
								item.rooms_number_in_group = 'ver';
							}else{
								item.rooms_number_in_group = '---';
							}
		                    return item;
		                });
		                that.date_selected = that.filter.date;
					}

					that.analytics = res.data.statistics;
					if(first){
						that.spaces = res.data.spaces;
						that.service_type_list_save = res.data.service_type_list;
					}
					that.user.hotel.hotel_name = (res.data.hotel == null) ? null : res.data.hotel.hvg_desc;
					that.service_type_list = (res.data.service_type_list == null) ? that.service_type_list : res.data.service_type_list;
					if(res.data.statistics.length > 0) {
						that.space_selected = that.filter.space_hotel;
					}

					// colocar data e local do titulo das estatisticas
					that.str_filter_space_hotel = that.filter.space_hotel.name;
					that.str_filter_date = that.filter.date == null ? null : moment(that.filter.date).format('DD-MM-YYYY');

					// bug fix - change to page 1
					if(!first){
						that.$refs.tabela.currentx = 1;
					}

					that.$vs.loading.close();

					// if(first && that.bookings.length != 0 && that.$route.name === 'int_my_bookings'){
						// var found_index = null,
						// 	highest_count = 0;
						// for (var i = 0; i < that.spaces.length; i++) {
						// 	if(that.spaces[i].space_type_id == 1 &&
						// 		that.spaces[i].booking_count > highest_count){
						// 		found_index = i;
						// 		highest_count = that.spaces[i].booking_count;
						// 	}
						// }
						// found_index = found_index != null ? found_index : 0;
						
						// // guardar o space hotel por default
						// that.original_filter_space_hotel.name = that.spaces[found_index].name;
						// that.original_filter_space_hotel.space_hotel_id = that.spaces[found_index].space_hotel_id;
						// that.original_filter_space_hotel.space_type_id = that.spaces[found_index].space_type_id;
						// // colocar o space hotel por default nos filtros
						// that.filter.space_hotel.name = that.spaces[found_index].name;
						// that.filter.space_hotel.space_hotel_id = that.spaces[found_index].space_hotel_id;
						// that.filter.space_hotel.space_type_id = that.spaces[found_index].space_type_id;

						// after get the default space_hotel, go get all marcacoes for today and the default space_hotel
						// that.get_my_bookings();
					// }
				}
					
			}).catch( function (err) {
				if(that.$route.name === 'int_my_bookings')
    				that.$router.push({name:'pageLogin'});
    			else
    				that.notify('ERR. 2', 'red');
    			that.$vs.loading.close();
			})
			.then(function() {
				if(!onlySpaces){
					that.show_pop_up_filter = false;
				}
				if(n_grupo != false){
					that.show_pop_up_row = false;
				}
			});
		},
		get_hour_interval_str: function(start_time, end_time) {
			return this.$t('str_hour_schedule').replace('{start_time}', this.get_hour_formated(start_time)).replace('{end_time}', this.get_hour_formated(end_time));
		},
		dp_set_dates: function() {
			let dts_available = this.analytics.filter((item, idx) => item.space_hotel_id === this.space_selected.space_hotel_id);
			if(dts_available.length > 0){
				this.dp.disabledDates.to = moment(dts_available[0].rsv_date).startOf('day').toDate();
				//this.dp.disabledDates.from = moment(dts_available[dts_available.length-1].rsv_date).startOf('day').toDate();
				this.date_selected = this.dp.disabledDates.to;
				this.dp.disabledDates.dates = [];
				for (let m = moment(this.dp.disabledDates.to); m.isBefore(this.dp.disabledDates.from); m.add(1, 'days')) {
				 	if(typeof dts_available.find((item, idx) => item.rsv_date === m.format('YYYY-MM-DD')) === 'undefined') {
				 		this.dp.disabledDates.dates.push(m.toDate());
				 	}
				}
			}
			
		},
		get_hour_formated: function(hour_min) {
			return hour_min.substring(0, 2)+ ":" +hour_min.substring(2);
		},
		update_num_people: function(item) {
			/*item.num_people_show = item.num_people_show;*/
		},
		handleSelected: function(item) {
			if(this.$route.name !== 'int_my_bookings')
				return;
			this.item_selected = item;
			this.item_selected.ocupacao_mesa_str = this.item_selected.qtd_mesa == null ? '---' : this.item_selected.ocupacao_mesa_str;
			this.show_pop_up_row = true;
		},
		send_people_show: function() {
			this.show_pop_up_row = false;
			if(this.item_selected.num_people_show_original == this.item_selected.num_people_show) {
				return;
			}
			this.saving = true;
			let that = this;
			this.$api({
				method: 'post',
				url: '/myvilagale/bookings/update_num_people_show',
				params: {
					token: this.user_token,
					reservation_distribution_id: this.item_selected.reservation_distribution_id,
					num_people_show: this.item_selected.num_people_show
				},
			}).then(function (res) {
				that.get_my_bookings();
				that.notify(this.$t('n_presencas_registado'), 'green');
			}).catch( function (err) {
				that.item_selected.num_people_show = that.item_selected.num_people_show_original;
				if(err.response.data.message == 'responses.error_reservation_distribution_id'){
					that.notify(this.$t('erro_numero_distribuicao_reserva'), 'red');
				}else if(err.response.data.message == 'responses.error_num_people_show'){
					that.notify(this.$t('erro_numero_pessoas'), 'red');
				}else{
					that.notify(this.$t('erro_guardar_n_presencas'), 'red');
				}
				
			}).then(function() {
				that.saving = false;
			});
		},
		get_schedule_list() {
			if(this.filter.date != null && 
				this.filter.space_hotel.space_hotel_id != null &&
					(
						(this.filter.space_hotel.space_type_id == 1 && this.filter.service_type != null) ||
						(this.filter.space_hotel.space_type_id != 1)
					)
				){

				//this.$vs.loading();
				let that = this;
				this.$api({
					method: 'get',
					url: '/myvilagale/bookings/get_availability',
					params: {
						token: this.user_token,
						space_hotel_id: this.filter.space_hotel.space_hotel_id,
						date: moment(this.filter.date).format('YYYY-MM-DD'),
						cod_hotel: this.user.hotel.hotel_id,
						lang: this.$i18n.locale,
						is_internal: 1,
					},
				}).then(function (res) {
					that.horarios = res.data.schedules;
					that.horarios = Object.values(that.horarios);
					that.set_schedule();
					
				}).catch( function (err) {
					//that.$router.push({name:'pageLogin'});
    				that.notify('ERR. 3', 'red');
				})
				.then(function() {
	    			//that.$vs.loading.close();
				});
			}
		},
		set_schedule(){
			this.schedule_list = [];
			for (let i = 0; i < this.horarios.length; i++) {
				for (let j = 0; j < this.horarios[i].length; j++) {

					if((this.filter.space_hotel.space_type_id == 1 && this.filter.service_type.service_type_id == this.horarios[i][j].service_type_id) ||
						(this.filter.space_hotel.space_type_id != 1)){

						this.horarios[i][j].label = this.horarios[i][j].start_time.slice(0, 2) + ":" + this.horarios[i][j].start_time.slice(2, 4) + ' - ' + this.horarios[i][j].end_time.slice(0, 2) + ":" + this.horarios[i][j].end_time.slice(2, 4);
						this.schedule_list.push(this.horarios[i][j]);
					}
				}
				
			}
		},
		keyboard_accept(text) {
          //alert("Input text: " + text);
          this.keyboard_hide();
        },
        keyboard_show(e) {
          this.keyboard.input = e.target;
          this.keyboard.layout = e.target.dataset.layout;
 
          if (!this.keyboard.visible)
            this.keyboard.visible = true
        },
        keyboard_hide() {
          this.keyboard.visible = false;
        }
	},
	computed: {
		str_date_selected: function() {
			return moment(this.date_selected).format('DD-MM-YYYY');
		},
		comp_analitics: function() {
			let en_date_selected = moment(this.date_selected).format('YYYY-MM-DD');
			return this.analytics.filter((item, idx) => item.rsv_date === en_date_selected && item.space_hotel_id === this.space_selected.space_hotel_id);
		},
		item_selected_title: function() {
			if(this.item_selected === null)
				return '';
			return '#' +this.item_selected.reservation_id+ ' | ' +this.item_selected.name+ ' | ' +this.item_selected.occupancy+ ' '+this.$t('Pessoas');
			//return '#' +this.item_selected.reservation_id+ ' ' +this.item_selected.reservation_date+ ' ' +this.get_hour_interval_str(this.item_selected.start_time, this.item_selected.end_time);
		}
	},
	watch: {
		show_pop_up_row: function(new_val, old_val) {
			if(!new_val) {
				this.item_selected.num_people_show = this.item_selected.num_people_show_original;
			}
		},
		space_selected: function(new_val, old_val) {
			this.dp_set_dates();
		},
		'$i18n.locale': function(new_value, old_val) {
			this.get_my_bookings();
		},
		'filter.space_hotel.space_hotel_id': function(new_value, old_val) {
			this.filter.service_type = null;
		},
		'filter.date': function(new_val, old_val) {
			this.schedule_list = [];
			if(this.cleaning){
				this.service_type_list = this.service_type_list_save;
			}
			this.filter.schedule = null;
			this.filter.service_type = null;
			this.get_my_bookings(false, true);
			
			if( moment(new_val).format('YYYY-MM-DD') != moment(new Date()).format('YYYY-MM-DD') ){
				this.occupancy_edit = false;
			}
		},
		'filter.space_hotel': function(new_val, old_val) {
			if(new_val.space_hotel_id != null){
				this.filter.schedule = null;
				this.schedule_list = [];
				this.get_schedule_list();
			}
			
		},
		'filter.service_type': function(new_val, old_val) {
			if(new_val != null && old_val == null){
				this.get_schedule_list();
			}else if (new_val != null && old_val != null){
				this.filter.schedule = null;
				this.set_schedule();
			}
			if(new_val == null && old_val != null){
				this.filter.schedule = null;
				this.schedule_list = [];
			}
		},
		show_pop_up_filter: function(new_val, old_val) {
			if(!new_val){

			}
		}
	},
	mounted() {
		let el = document.querySelector(".bookings-table .vs-table--search-input");
		let that = this;
		if(el.onfocus === null) {
			el.dataset.layout = "normal";
			el.onfocus = function(e) {
				that.keyboard_show(e);
			};
			/*el.onblur = function(e) {
				that.keyboard_hide(e);
			};*/
		}
		
	},
	created() {
		if(this.$route.name === 'int_my_bookings') {
			this.str_filter_date = null;//moment(new Date()).format('DD-MM-YYYY');
			this.user = {
				usertoken: this.$route.params.token,
				hotel: {
					hotel_id: this.$route.params.hotelId,
					hotel_name: null,
					num_reserva: null,
					room_number: null,
					nome: null,
					check_out: {
						date: moment(this.booking_date_selected).add(2, 'months').format('YYYY-MM-DD')
					}
				}
			};
			this.user_token = this.$route.params.token;
			this.date_options.disabledDates.to = moment(new Date()).subtract(6, 'months').startOf('day').toDate();
		} else {
			this.user_token = this.user.usertoken;
		}
		// if(this.$route.meta.public && Object.keys(this.user.hotel).length !== 0) {
			this.get_my_bookings(true);
		// }
	},
}
</script>

<style scoped>
	.table_schedule_wrapper {
		position: relative;
		z-index: 0;
	}
	.table_schedule_wrapper .vs-input-number, .table_dish_wrapper .vs-input-number {
		background-color: transparent;
	}
	.datePickerDiv >>> input {
	  border: none;
	  background: transparent;
	  color: transparent;
	  width: 0;
	  height: 0;
	}
	.datePickerDiv >>> .vdp-datepicker {
	  right: 96px;
	  width: 0;
	  height: 0;
	}
	.datePickerDiv >>> .vdp-datepicker__calendar {
		top: 0;
		z-index: 999;
		height: 282px;
	}
	.datePickerDiv >>> .vdp-datepicker__calendar > div {
		background-color: #ffffff;
	}
	.stats-card >>> .vs-dropdown-menu {
		width: 130px;
	}
	.stats-card .vue-select {
		min-width: 240px;
	}
	.icon-calendar:before {
	    content: "";
	}
	.logo-text{
        font-size: 26px;
        font-weight: 600;
        color: #4A4E4F;
        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
		font-family: 'Titillium Web',sans-serif;
      }
      @media screen and (max-width: 767.98px) {
      	.my-bookings-page  >>>.vx-card__actions {
      		width: 100%;
      		text-align: right;
      	}
      	.stats-card .vue-select, .icon-calendar {
			margin-top: 10px;
		}
		.datePickerDiv >>> .vdp-datepicker {
			right: 10px;
		}
      }
      @media screen and (max-width: 450px) {
      	.datePickerDiv >>> .vdp-datepicker {
			right: -50px;
		}
      }
      @media screen and (max-width: 376px) {
      	.datePickerDiv >>> .vdp-datepicker {
			right: -10px;
		}
      }
</style>
<style scoped>
	.bookings-table >>> .con-pagination-table .vs-pagination--mb {
		width: 100% !important;
		padding: 0 !important;
	}
	.v-touch-keyboard {
    	z-index: 99999;
    	background-color: #ffffff;
    	position: fixed;
    	width: 70%;
    	left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto auto;
	    padding: 1em;
	    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.3);
	    border-radius: 10px;
    }
    .v-touch-keyboard >>> .keyboard .key {
    	font-size: 1.45em;
    }
    @media screen and (max-width: 992px) {
		.v-touch-keyboard {
	    	width: 100%;
		}
	}
</style>
<style>
    .filter_date .vdp-datepicker__calendar{
    	bottom: inherit;
    }
    
</style>